/* eslint-disable jsdoc/no-undefined-types */
import cartData from '#shared/util/cartData.js';
import invalidCartRedirectMiddleware from '#shared/middleware/invalidCartRedirectMiddleware.js';
import getCartMiddleware from '#shared/middleware/getCartMiddleware.js';
import paymentReturnMiddleware from '#shared/middleware/paymentReturnMiddleware.js';

import cBillingSummary from '#themes/default/default/components/billingSummary/billingSummary.js';
import cButton from '#themes/default/default/components/button/button.js';
import cButtons from '#themes/default/default/components/buttons/buttons.js';
import cCompanySummary from '#themes/default/default/components/companySummary/companySummary.js';
import cInfoBox from '#themes/default/default/components/infoBox/infoBox.js';
import cLegalAgreement from '#themes/default/default/components/legalAgreement/legalAgreement.js';
import cLegalAgreementCheckbox from '#themes/default/default/components/legalAgreementCheckbox/legalAgreementCheckbox.js';
import cPaymentSummary from '#themes/default/default/components/paymentSummary/paymentSummary.js';

import template from './confirmOrder.html' with { type: 'html' };

/**
 * @memberof ConfirmOrderPage
 * @feature T&Cs with dynamic links [GEN]
 * @feature T&Cs checkbox (when scrollbar present) [GEN]
 * @feature Product description changes based on selected PM (online/offline) [GEN]
 */
export default {
	...cartData,
	middleware: [
		invalidCartRedirectMiddleware,
		getCartMiddleware,
		paymentReturnMiddleware
	],
	components: {
		cBillingSummary,
		cButton,
		cButtons,
		cCompanySummary,
		cInfoBox,
		cLegalAgreement,
		cLegalAgreementCheckbox,
		cPaymentSummary
	},
	meta() {
		return {
			title: `${this.t('global_metaTitle')} - ${this.t('confirmOrder_metaTitle')}`
		};
	},
	computed: {
		areTermsAccepted() {
			return this.$store.getters.areTermsAccepted;
		},
		hasTermsCheckbox() {
			return this.$store.getters.hasTermsCheckbox || this.isCustomId['CART-4095'];
		},
		showDisclaimer() {
			return this.$store.getters.showDisclaimer;
		},
		getSubmitTextKey() {
			if (this.isCustomId['CART-2967']) {
				return 'cart_subscribe';
			}
			return 'cart_submit';
		},
		backButtonPath() {
			let path = 'shopping-cart';
			if (this.isCompany) {
				path = 'company-details';
			} else if (this.order.isBrazilianFlow) {
				path = 'payment-details';
			}
			return path;
		}
	},
	created() {
		this.utils.showLoader();
	},
	async mounted() {
		await this.waitUntil([() => this.payment.owner && this.payment.owner.billing.email], 60 * 1000);
		this.tracking.checkout({
			url: this.url,
			page: this.page,
			order: this.order,
			theme: this.theme,
			app: this.app
		});
		this.tracking.review({
			url: this.url,
			page: this.page,
			order: this.order,
			theme: this.theme,
			app: this.app,
			selectedPayment: this.selectedPayment
		});
		// Set focus on confirm order page to reset tab position
		this.$refs.confirmOrder.focus();
		this.utils.hideLoader();
	},
	methods: {
		async handleCheckoutFormSubmit() {
			this.utils.showLoader();
			try {
				if (await this.utils.submitOrder()) {
					await this.$router.push(this.getLink('thank-you')).catch(() => {});
				}
			} catch (error) {
				this.utils.setPaymentFailed(error);
				await this.$nextTick();
				await this.$router.push(this.getLink('shopping-cart')).catch(() => {});
			}
		},
		focusTermsCheckbox() {
			const termsCheckbox = document.querySelector('.legalAgreementCheckbox .checkbox_button');
			// Focus T&C checkbox on button click
			if (termsCheckbox) {
				termsCheckbox.focus();
			}
			// Set terms status to seen = visibly different styling for checkbox + text
			this.$store.commit('SET_TERMS_AGREEMENT', {
				checkbox: true,
				seen: true
			});
		}
	},
	template
};
